<script lang="ts">
  import { page } from '$app/state';
</script>

<main id="main-content" class="container py-3">
  <div class="py-5">
    <div class="row">
      <div class="col col-md-8 col-lg-6 mx-auto">
        <div class="card">
          <div class="card-header"><h1 class="mb-0">Welcome</h1></div>
          <div class="card-body">
            <p>Please log in with UAMS Single Sign On</p>
            <div class="d-grid">
              <a href="/saml/login?returnUrl={page.url.pathname}" class="btn btn-primary">Log in</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
